<div class="panel">
  <div class="panel-content">
    <div class="p-3">
      <div class="d-flex align-items-center">
        Đang xử lý...
        <div class="spinner-border spinner-border-sm" role="status">
          <span class="sr-only">Loading...</span>
      </div>
      </div>
    </div>
  </div>
</div>
